import { useStore } from 'effector-react'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { $isDocumentsDrawerOpen, closeDocumentsDrawer } from './model'
import { Title, Wrapper } from './styled'
import { DocumentOffer, RentalContract } from './ui'

export function Documents() {
  const isOpen = useStore($isDocumentsDrawerOpen)

  return (
    <DrawerComponent isShow={isOpen} onCancel={closeDocumentsDrawer}>
      <Title>Документы</Title>

      <Wrapper>
        <DocumentOffer />

        <RentalContract />
      </Wrapper>
    </DrawerComponent>
  )
}
